import { NavLink } from 'react-router-dom';
import { AppBar, Typography, Icon, Stack } from '@mui/material';
import proptypes from 'prop-types';
import Search from '../../Search';
import { useGetProfileQuery } from '../../../features/api/rest/apiProfileSlice';
import ToLoginButton from './ToLoginButton';
import AccountMenu from './AccountMenu';

function MainNavBar({ search = false }) {
  const { data: user } = useGetProfileQuery();

  return (
    <AppBar
      data-testid="MainNavBar"
      component="nav"
      color="primary"
      position="static"
      sx={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '70px',
        px: '16px',
        py: '8px',
      }}
    >
      <NavLink
        to="/"
        style={{
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
          color: 'inherit',
          flex: '0 0 15%',
        }}
      >
        <Icon sx={{ fontSize: '40px' }}>
          <img data-testid="LogoIcon" src="favicon.svg" alt="logo" style={{ width: '100%', height: 'auto', display: 'block' }} />
        </Icon>
        <Typography data-testid="LogoText" variant="h5" color="inherit" sx={{ ml: 1, fontSize: '20px', textDecoration: 'none', lineHeight: '100%', display: { xs: 'none', md: 'block' } }}>
          Food Advisor
        </Typography>
      </NavLink>
      {search && <Search location="navigationBar" />}
      <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ flex: '0 0 15%' }}>
        {!user && <ToLoginButton />}
        {user && <AccountMenu />}
      </Stack>
    </AppBar>
  );
}

MainNavBar.propTypes = {
  search: proptypes.bool,
};

export default MainNavBar;
